module.exports = __webpack_public_path__ + "static/img/icon_money.f951eb37.png";